import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import { useTable } from './Table';
var TableCell = /*#__PURE__*/React.forwardRef(function TableCell(_ref, ref) {
  var _ref$wrapText = _ref.wrapText,
      wrapText = _ref$wrapText === void 0 ? 'auto' : _ref$wrapText,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      mono = _ref.mono,
      rest = _objectWithoutPropertiesLoose(_ref, ["wrapText", "align", "mono"]);

  var _useTable = useTable(),
      size = _useTable.size;

  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "td",
    role: "cell",
    ref: ref,
    p: size === 'medium' ? 4 : 2,
    fontSize: "medium",
    textAlign: align,
    overflowWrap: wrapText === 'wrap' ? 'break-word' : undefined,
    whiteSpace: wrapText === 'nowrap' ? 'nowrap' : undefined,
    verticalAlign: "middle",
    fontFamily: mono ? 'mono' : undefined
  }, rest));
});
export default /*#__PURE__*/React.memo(TableCell);